import * as actionTypes from './actionTypes';
import * as actions from './index';

export const nlwLoadStatistics = (from, /*to,*/ host) => {
    return dispatch => {
        const types = ['SEARCH','CLIPVIEW','LOGIN'];
        types.forEach(type => {
            dispatch(getStats(type, from, host));
        });
        /*
        dispatch(getStats('SEARCH', from, host));
        dispatch(getStats('CLIPVIEW', from, host));
        dispatch(getStats('LOGIN', from, host));
        */
    };
}

const getStats = (type, from, host) => {
    /*console.log(from);
    console.log((new Date(from+" 00:00:00 GMT+1")).toISOString());
    console.log((new Date()).toISOString());
    const fromStr = (new Date(from+" 00:00:00")).toISOString();
    const toStr = (new Date()).toISOString();*/
    
    if(typeof from === 'string') {
        from = from.replaceAll('/','-');
    }

    return dispatch => {
        window.flow.nlwStatsGet(type, from/*, fromStr, toStr*/).then(res => {
			console.log(type, res);
            dispatch({ type: actionTypes.NLW_GET_STATS_SUCCESS, host: host, stats: type, data: { [type]: res }});
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const nlwStatsViewclip = (id) => {
    console.log(id);
    return dispatch => {
        window.flow.nlwStatsViewclip(id).then(res => {
            //dispatch({ type: actionTypes.NLW_GET_STATS_SUCCESS, data: { [type]: res }});
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
};
